import React, { useState, KeyboardEvent, ChangeEvent, useRef, useEffect } from 'react';
import { Chip } from 'Components/atoms';
import close from 'Assets/icons/close.svg';
import './styles.scss';

export type ChipInputProps = {
    initialChips?: string[];
    onChange?: (chips: string[]) => void;
};

const ChipInput: React.FC<ChipInputProps> = ({ initialChips = [], onChange }) => {
    const [chips, setChips] = useState<string[]>(initialChips);
    const [input, setInput] = useState<string>('');
    const inputRef = useRef<HTMLInputElement>(null);

    const handleAddChip = () => {
        const trimmed = input.trim();
        if (trimmed && !chips.includes(trimmed)) {
            const updated = [...chips, trimmed];
            setChips(updated);
            onChange?.(updated);
        }
        setInput('');
    };

    const handleRemoveChip = (chipToRemove: string) => {
        const updated = chips.filter((chip) => chip !== chipToRemove);
        setChips(updated);
        onChange?.(updated);
    };

    const handleKeyDown = (e: KeyboardEvent<HTMLInputElement>) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            handleAddChip();
        }
    };

    const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
        setInput(e.target.value);
    };

    useEffect(() => {
        setChips(initialChips.filter((chip) => chip.trim() !== ''));
    }, [initialChips]);

    return (
        <div className="chip-input-container" onClick={() => inputRef.current?.focus()}>
            {chips.map((chip) => (
                <Chip
                    key={chip}
                    value={chip}
                    variant="user_score"
                    onClose={() => handleRemoveChip(chip)}
                    endIcon={close}
                />
            ))}
            <input
                ref={inputRef}
                className="chip-input-field"
                type="text"
                value={input}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                placeholder="Type and press Enter or Space"
            />
        </div>
    );
};

export default ChipInput;
